import {
  type AcceptTransferCodeRequest,
  AcceptTransferCodeResponse,
  type UpsertTransferCodeRequest,
  UpsertTransferCodeResponse,
} from "schema/gen/es/chiikipoint/wallet/v2/service_pb";

// 送金コードの有効期限（現在時刻から5分後）
const TRANSFER_CODE_EXPIRY_MINUTES = 5;

// 生成されるモック送金コードの長さ
const TRANSFER_CODE_LENGTH = 6;

// モック送金コードのマッピング（コード -> 金額）を保持
const mockTransferCodes = new Map<string, number>();

/**
 * 指定された長さのランダムな英数字コードを生成
 */
function generateTransferCode(length: number): string {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

/**
 * UpsertTransferCode RPCのモックハンドラー
 * 送金コードを生成または更新します
 */
export function handleUpsertTransferCode(req: UpsertTransferCodeRequest) {
  // モック送金コードを生成
  const transferCode = generateTransferCode(TRANSFER_CODE_LENGTH);

  // 送金コードと金額のマッピングを保存
  mockTransferCodes.set(transferCode, Number(req.amount));

  // 有効期限（現在から15分後）
  const expiresAt = new Date();
  expiresAt.setMinutes(expiresAt.getMinutes() + TRANSFER_CODE_EXPIRY_MINUTES);

  return new UpsertTransferCodeResponse({
    transferCode: transferCode,
    expiresAt: {
      seconds: BigInt(Math.floor(expiresAt.getTime() / 1000)),
      nanos: 0,
    },
  });
}

/**
 * AcceptTransferCode RPCのモックハンドラー
 * 送金コードを受け取り、対応する金額を返します
 */
export async function handleAcceptTransferCode(
  _req: AcceptTransferCodeRequest,
) {
  await new Promise((resolve) => setTimeout(resolve, 500));
  return new AcceptTransferCodeResponse({
    amount: BigInt(1000),
  });
}
